import { RemovableRef, useSessionStorage } from '@vueuse/core';

export function useResponsive(): {
	bannerVisible: RemovableRef<boolean>;
	isMobile: boolean;
	hideMobileBanner: () => void;
	showMobileBanner: () => void;
} {
	const userAgent = navigator.userAgent;
	const isMobile = userAgent?.includes('Mobi');

	const bannerVisible: RemovableRef<boolean> = useSessionStorage('ce-responsive-mobile-banner', isMobile);

	const showMobileBanner = () => (bannerVisible.value = true);
	const hideMobileBanner = () => (bannerVisible.value = false);

	return {
		bannerVisible,
		isMobile,
		hideMobileBanner,
		showMobileBanner
	};
}
